let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPvem")).then(() => parcelRequire('1qE6O'));